import { render, staticRenderFns } from "./ListProgressNotifications.vue?vue&type=template&id=1500a280"
import script from "./ListProgressNotifications.vue?vue&type=script&lang=js"
export * from "./ListProgressNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports